import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Define the primary color for the theme
export const PRIMARY_COLOR = "#C21B17"; // Example primary color
export const SECONDARY_COLOR = "#6F7072"; // Example secondary color
export const SECONDARY_COLOR_LIGHT = "#B0B2B3"; // Example secondary color
export const BACKGROUND_COLOR = "#F9F9F9"; // Example background color

// Create a theme instance.
const genTheme = createTheme({
  palette: {
    background: {
      default: "#FFFAFA",
    },
    primary: {
      main: PRIMARY_COLOR,
      light: "#701230",
      dark: PRIMARY_COLOR,
    },
    secondary: {
      main: SECONDARY_COLOR,
      light: "#B0B2B3",
      dark: "#656565",
    },
    error: {
      main: red.A400,
    },
    success: {
      main: "#2e7d32",
    },
  },
  typography: {
    fontFamily: '"Noto Sans Thai", "Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    h1: {
      color: PRIMARY_COLOR,
      fontSize: 18,
      fontWeight: "semi-bold",
    },
    h2: {
      color: PRIMARY_COLOR,
      fontSize: 16,
      fontWeight: "semi-bold",
    },
    h3: {
      color: SECONDARY_COLOR,
      fontSize: 14,
      fontWeight: "semi-bold",
    },
    h4: {
      color: SECONDARY_COLOR,
      fontSize: 14,
      fontWeight: "normal",
    },
    body1: {
      color: "#111111",
      fontSize: 14,
    },
    body2: {
      color: "#656565",
      fontSize: 14,
    },
    caption: {
      color: "#BABABA",
      fontSize: 10,
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        sx: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        margin: "dense",
        size: "medium",
      },
    },
    MuiButton: {
      defaultProps: {
        variant: "contained",
        size: "medium",
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        textPrimary: {
          color: PRIMARY_COLOR,
          "&:hover": {
            boxShadow: "none",
            backgroundColor: "transparent",
          },
        },
      },
    },
  },
});

export default genTheme;
